<template>
  <div :class="{ 'box-search-wrap': hasBox }">
    <div class="tools_wrap" style="display: flex;justify-content: space-between;align-items: center;">
      <div class="query_wrap" style="display: inline-block; width:100%;">
        <div
          class="query_item"
          :class="ifShowBorder ? 'search-item' : item.width"
          v-show="canShow(index)"
          v-for="(item, index) in localQueryConfig"
          :key="item.key"
        >
          <div class="label" style="width:84px;margin-left:10px">
            {{ item.label }}
          </div>
          <div class="con value">
            <el-input
              v-if="item.kjlx == 'input' || !item.kjlx"
              class="my_inp"
              v-model="value[item.key]"
              :placeholder="'请输入' + item.label"
              :size="ifShowBorder ? 'mini' : 'small'"
              clearable
              style="width:160px"
            ></el-input>
            <el-radio-group v-if="item.kjlx == 'radio'" v-model="value[item.key]">
              <el-radio v-for="(item2, index2) in item.list" :key="index2" :label="item2.value" :content="item2.label"></el-radio>
            </el-radio-group>
            <el-input
              v-if="item.kjlx == 'number'"
              class="my_inp"
              type="float"
              v-model="value[item.key]"
              :placeholder="'请输入' + item.label"
              :size="ifShowBorder ? 'mini' : 'small'"
            >
            </el-input>
            <el-select
              @change="bxChange"
              v-if="item.kjlx == 'select' && item.type == 'insureComId'"
              :disabled="item.disabled"
              v-model="value[item.key]"
              :placeholder="'请选择' + item.label"
              :size="ifShowBorder ? 'mini' : 'small'"
              class="my_inp"
              clearable
              style="width:160px"
            >
              <el-option v-for="item2 in item.list" :key="item2.value" :value="item2.value" :label="item2.label"></el-option>
            </el-select>
            <el-select
              v-if="item.kjlx == 'select' && item.type != 'insureComId'"
              :filterable="item.type == 'tisId' || item.filterable"
              :disabled="item.disabled"
              v-model="value[item.key]"
              :placeholder="'请选择' + item.label"
              :size="ifShowBorder ? 'mini' : 'small'"
              class="my_inp"
              clearable
              style="width:160px"
            >
              <el-option v-for="item2 in item.list" :key="item2.value" :value="item2.value" :label="item2.label"></el-option>
            </el-select>
            <el-date-picker
              v-if="item.kjlx == 'date'"
              v-model="value[item.key]"
              :placeholder="'请选择' + item.label"
              value-format="yyyy-MM-dd"
              class="my_inp"
              :size="ifShowBorder ? 'mini' : 'small'"
              type="date"
              unlink-panels
            ></el-date-picker>
            <el-date-picker
              v-if="item.kjlx == 'month'"
              v-model="value[item.key]"
              :placeholder="'请选择' + item.label"
              value-format="yyyyMM"
              class="my_inp"
              :size="ifShowBorder ? 'mini' : 'small'"
              type="month"
              unlink-panels
              style="width:160px!important"
            ></el-date-picker>
            <el-date-picker
              v-if="item.kjlx == 'daterange'"
              v-model="value[item.key]"
              :placeholder="'请选择' + item.label"
              value-format="yyyy-MM-dd"
              class="my_inp"
              :size="ifShowBorder ? 'mini' : 'small'"
              range-separator="至"
              start-placeholder="开始日期"
              style="width: 420px;"
              end-placeholder="结束日期"
              type="daterange"
              unlink-panels
              @change="changeRange($event, item)"
            >
            </el-date-picker>
            <el-date-picker
              v-if="item.kjlx == 'datetime'"
              v-model="item.value"
              :placeholder="'请选择' + item.label"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="my_inp"
              :size="ifShowBorder ? 'mini' : 'small'"
              type="datetime"
              unlink-panels
            ></el-date-picker>
            <el-date-picker
              v-if="item.kjlx == 'datetimerange'"
              v-model="value[item.key]"
              :placeholder="'请选择' + item.label"
              value-format="yyyy-MM-dd HH:mm:ss"
              class="my_inp"
              :size="ifShowBorder ? 'mini' : 'small'"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              type="datetimerange"
              style="width: 420px;"
              unlink-panels
              @change="changeRange($event, item)"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
    </div>
    <div
      class="query_btn_wrap"
      :class="{ 'top-border': ifBtnWrap }"
      style="padding-right:22px;flex: 0 0 240px;white-space: nowrap;text-align: right;position:relative"
    >
      <div v-if="total > -1" class="count-title">
        共筛选出<span style="color:#0C6FFF">{{ total }}</span
        >条记录
      </div>
      <div v-if="retractShow" class="retract" @click="retractChange">
        <span>{{ retract ? "展开" : "收起" }}</span>
        <img src="@/assets/images/up.png" :style="retract ? { transform: 'rotate(180deg)' } : ''" alt="" />
      </div>
      <el-button class="my_btn" :size="ifShowBorder ? 'mini' : 'small'" @click="resetQuery">重置</el-button>
      <el-button class="my_btn" type="primary" :size="ifShowBorder ? 'mini' : 'small'" @click="query">查询 </el-button>
      <!-- <slot>
                <el-button v-if="isAdd" class="my_btn"  :size="ifShowBorder?'mini':'small'" type="danger"
                    @click="$emit('add')" style="margin-left:10px;">新增</el-button>
            </slot> -->
    </div>
  </div>
</template>
<script>
import { tenantPage } from "@/api/tenant";
import { queryInspectCategoryList } from "@/api/inspectcategory";
import { govQueryInsureComList } from "@/api/user";

import { querySysCompanyPageByManage, qeryInsureComEntryTisList } from "@/api/base";
export default {
  name: "SearchList",
  props: {
    total: {
      type: Number,
    },
    ifBtnWrap: {
      type: Boolean,
      default: true,
    },
    ifShowBorder: {
      type: Boolean,
      default: true,
    },
    // tableConfig: { type: Object, default: () => {} },
    queryConfig: { type: Array, default: () => [] },
    value: { type: Object, default: () => {} },
    isAdd: {
      type: Boolean,
      default: false,
    },
    hasBox: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    window.onresize = () => {
      this.setScreenWidth();
    };
  },
  created() {
    this.initParams = {
      ...this.value,
    };
    // this.queryConfig.forEach((item) => {
    //   if (item.key == "tenantId") {
    //     this.getTenantPage(item);
    //   } else if (item.type == "tisName") {
    //     this.getTisName(item);
    //   } else if (item.type == "tisId") {
    //     this.getTisId(item);
    //   } else if (item.key == "inspectTypeTwo") {
    //     //风险类型
    //     this.getInspectTypeTwo(item);
    //   }
    // });
  },
  watch: {
    queryConfig: {
      handler(val) {
        this.localQueryConfig = val;
        this.localQueryConfig.forEach((item) => {
          if (item.key == "tenantId") {
            this.getTenantPage(item);
          } else if (item.type == "tisName") {
            this.getTisName(item);
          } else if (item.type == "tisId" && !item.noAutoLoad) {
            this.getTisId(item);
          } else if (item.key == "inspectTypeTwo") {
            //风险类型
            this.getInspectTypeTwo(item);
          } else if (item.key == "insureComId" && !item.noAutoLoad) {
            //风险类型
            this.getinsureComId(item);
          }
        });
        // console.log(val);
        this.localQueryConfig.forEach((item) => {
          if (["daterange", "datetime", "date"].includes(item.kjlx) && Array.isArray(item.value) && item.value.length) {
            this.value[item.key1] = item.value[0].format("yyyy-MM-dd hh:mm:ss");
            this.value[item.key2] = item.value[1].format("yyyy-MM-dd hh:mm:ss");
            this.value[item.key] = item.value;
          } else {
            if (![null, undefined, ""].includes(item.value)) this.value[item.key] = item.value;
          }
        });
        this.localQueryConfig = [...this.localQueryConfig];
      },
      immediate: true,
    },
  },
  model: {
    event: "change",
  },
  computed: {
    retractShow() {
      return this.localQueryConfig.length > this.eachLineCount;
    },
    isBxOrSc() {
      let flag = false;
      let type = this.$store.state.user.userinfo ? this.$store.state.user.userinfo.userType : "";
      if (type == 2 || type == 9) flag = true;
      return flag;
    },
    isTzzj() {
      return this.$store.getters["user/isTzzj"];
    },
  },
  data() {
    return {
      localQueryConfig: [],
      eachLineCount: 4, //初始化收起后展示搜索项数量
      screenWidth: document.documentElement.clientWidth, //屏幕宽度
      retract: this.isTzzj ? true : false,
      initParams: {},
    };
  },
  methods: {
    bxChange(val) {
      const value = JSON.parse(JSON.stringify(this.value));
      value.tisId = null;
      this.$emit("change", value);

      for (let item of this.localQueryConfig) {
        if (item.type == "tisId") {
          if (!item.originList) break;
          if (!val) {
            item.list = item.originList.map((key) => {
              return {
                label: key.comName,
                value: key.id,
              };
            });
          } else {
            item.list = item.originList
              .filter((key) => {
                return key.insureComId == val;
              })
              .map((key) => {
                return {
                  label: key.comName,
                  value: key.id,
                };
              });
          }

          break;
        }
      }

      this.localQueryConfig = [...this.localQueryConfig];
    },
    setScreenWidth() {
      this.screenWidth = document.documentElement.clientWidth;
      this.eachLineCount = Math.round((this.screenWidth - 300) / 300);
    },
    canShow(index) {
      if (!this.retract) {
        return true;
      }
      this.setScreenWidth();
      return index >= this.eachLineCount ? false : true;
    },
    retractChange() {
      this.retract = !this.retract;
    },
    getInspectTypeTwo(item) {
      queryInspectCategoryList({}).then((res) => {
        // debugger
        var list = [
          {
            label: "全部",
            value: "",
          },
        ];
        if (res && res.length) {
          res[0].categoryList.forEach((item) => {
            list.push({
              label: item.categoryName,
              value: item.id,
            });
          });
          //   res.forEach(item => {

          //   })
        }
        item.list = list;
      });
    },
    getTisId(item) {
      let task;
      if (this.isBxOrSc) {
        task = qeryInsureComEntryTisList;
      } else {
        task = querySysCompanyPageByManage;
      }
      task({
        comType: 3,
        pageIndex: 1,
        pageSize: 100,
      }).then((res) => {
        var list = [
          {
            label: "全部",
            value: "",
          },
        ];
        if (res.data) {
          res.data.forEach((item) => {
            list.push({
              label: item.comName,
              value: item.id,
            });
          });
        }
        item.list = list;
        item.originList = res.data;
      });
    },
    getinsureComId(item) {
      govQueryInsureComList({
        pageSize: 200,
        pageIndex: 1,
      }).then((res) => {
        var list = [
          {
            label: "全部",
            value: "",
          },
        ];
        if (res.data) {
          res.data.forEach((item) => {
            list.push({
              label: item.comName,
              value: item.id,
            });
          });
        }
        item.list = list;
      });
    },
    getTisName(item) {
      let task;
      if (this.isBxOrSc) {
        task = qeryInsureComEntryTisList;
      } else {
        task = querySysCompanyPageByManage;
      }
      task({
        // comT
        comType: 3,
        pageIndex: 1,
        pageSize: 100,
      }).then((res) => {
        var list = [
          {
            label: "全部",
            value: "",
          },
        ];
        if (res.data) {
          res.data.forEach((item) => {
            list.push({
              label: item.comName,
              value: item.comName,
            });
          });
        }
        item.list = list;
      });
    },
    getTenantPage(item) {
      tenantPage({
        pageIndex: 1,
        pageSize: 100,
      }).then((res) => {
        var list = [];
        if (res.data) {
          res.data.forEach((item) => {
            list.push({
              label: item.name,
              value: item.id,
            });
          });
        }
        item.list = list;
      });
    },
    changeRange(val, item) {
      if (val) {
        item.value = val.join("/");
      } else {
        item.value = "";
      }
      var cusVal = JSON.parse(JSON.stringify(this.value));
      if (item.key1 && item.key2) {
        if (val && val.length) {
          cusVal[item.key1] = val[0] + " 00:00:00";
          cusVal[item.key2] = val[1] + " 23:59:59";
        } else {
          cusVal[item.key1] = "";
          cusVal[item.key2] = "";
        }
        this.$emit("change", cusVal);
        this.$emit("on-change", cusVal);
      }
    },
    resetQuery() {
      // this.localQueryConfig = this.localQueryConfig.map((item) => {
      //   console.log(item);
      //   return {
      //     ...item,
      //     value: null,
      //   };
      // });
      var obj = {
        ...this.initParams,
      };
      this.$emit("change", obj);
      this.$emit("on-change", obj);
      this.$emit("query");
    },
    query() {
      var obj = {
        ...this.value,
        pageIndex: 1,
      };
      if (obj && obj.insureCode) {
        obj.insureCode = obj.insureCode.replace(/\s*/g, "");
      }
      this.$emit("change", obj);
      this.$emit("on-change", obj);
      this.$emit("query");
    },
  },
};
</script>

<style lang="scss" scoped>
.query_item ::v-deep {
  /* flex: 0 0 30%; */
  display: inline-flex;
  min-width: 260px;
}
.search-item {
  // background-color: #f7f8fa;
  margin-right: 12px;
  margin-bottom: 12px;
  border-radius: 2px;
  height: 38px;
  border: 1px solid rgba(233, 233, 233, 1);
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;

  .label {
    // padding-left: 12px;
    color: rgba(153, 153, 153, 1);
    width: 80px;
    font-size: 14px;
  }
  .value {
    ::v-deep .el-input__inner {
      border: none !important;
      // background-color: #f7f8fa !important;
    }
    ::v-deep .el-select__caret {
      color: black;
      // background-color: #f7f8fa !important;
    }
    ::v-deep .el-range-input {
      color: black;
      // background-color: #f7f8fa !important;
    }
    ::v-deep .el-date-editor {
      color: black;
      width: 448px !important;
      // background-color: #f7f8fa !important;
    }
  }
}
.top-border {
  border-top: 1px solid #e6e6e6;
  padding-top: 12px;
  position: relative;
  .retract {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: white;
    padding: 6px;
    color: #0c6fff;
    top: -1px;
    border: 1px solid lightgray;
    border-top: none;
    left: 50%;
    position: absolute;
    // margin-left: 50%;
    // transform: translateX(-50%);
    cursor: pointer;
    display: flex;
    display: inline-block;
    align-items: center;
    // color: #999999;
    font-size: 12px;
    img {
      margin-left: 9px;
      width: 12px;
    }
  }
}
.count-title {
  left: 10px;
  position: absolute;
  // left: ;
  color: #000000;
  font-size: 14px;
  font-weight: 550;
  top: 20px;
}
</style>
